import { getProviders, signIn } from "next-auth/react"
import { EventEmitter } from "./EventUtil"

export const checkAuth = async session => {
  if (!session) {
    const providersObject = await getProviders()
    const providers = providersObject ? Object.values(providersObject) : null
    EventEmitter.emit("OpenPopup", {
      title: "Login required",
      message: "Login to make a purchase",
      status: "warning",
      onOk: () => (providers && providers.length > 0 ? signIn(providers[0].id) : {}),
      okLabel: "Login",
      onCancel: () =>
        (document.location.href = `${process.env.NEXT_PUBLIC_VENLY_AUTH_URL}/auth/realms/Arkane/protocol/openid-connect/registrations?response_type=code&scope=openid&client_id=Tribly&redirect_uri=${process.env.NEXT_PUBLIC_SITE_URL}`),
      cancelLabel: "Create account",
    })
    return false
  }

  return true
}
